import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "./HartuTimeSelect.css";
import "select2";

export default function HartuTimeSelect({
  availableHours,
  hoursLoading,
  lang,
  onChange,
  t,
  maxCapacity
}) {
  const selectRef = useRef();
  const capacitiesRef = useRef({});
  const selectedValueRef = useRef(null);

  const loadingText = t.loading_schedules?.[lang] || "Cargando horarios...";
  const placeholderText = t.select_a_timetable?.[lang] || "Selecciona horario...";

  useEffect(() => {
    if (hoursLoading || !selectRef.current) return;

    const $select = $(selectRef.current);
    const capacitiesMap = {};

    if ($select.data("select2")) {
      $select.select2("destroy");
    }

    $select.empty();

    // placeholder real
    $select.append($("<option>").val("").text(""))

    availableHours.forEach(([day, hours]) => {
      if (!Array.isArray(hours)) return;

      const $group = $("<optgroup>").attr("label", day);

      hours.forEach((hour) => {
        const value = `${day} ${hour.range}`;
        const text = `${day} ${hour.range} (${hour.capacity})`;

        capacitiesMap[value] = hour.available_capacity;

        $group.append($("<option>").val(value).text(text))
      });

      $select.append($group);
    });

    capacitiesRef.current = capacitiesMap;

    $select.select2({
      placeholder: placeholderText,
      allowClear: false,
      closeOnSelect: true,
      width: "100%",
      minimumResultsForSearch: 5,
    });

    if (selectedValueRef.current) {
      $select
        .val(selectedValueRef.current)
        .trigger("change");
    }

    const handleSelectChange = () => {
      const value = $select.val()
      
      selectedValueRef.current = value;

      if (value) {
        maxCapacity(
          capacitiesRef.current[value] ?? 0
        );

        onChange([value]);
      } else {
        maxCapacity(0);
        onChange([]);
      }
    };

    $select.off("change").on("change", handleSelectChange)

    return () => {
      $select.off("change", handleSelectChange)
      
      if ($select.data("select2")) {
        $select.select2("destroy");
      }
    };
  }, [availableHours, hoursLoading, lang, placeholderText, onChange, maxCapacity]);

  if (hoursLoading) {
    return (
      <div className="hartuTimeSelect__wrapper hartuTimeSelect__loader">
        <div className="hartuTimeSelect__loadingText">
          {loadingText}
        </div>
      </div>
    );
  }

  return (
    <div className="hartuTimeSelect__wrapper">
      {!availableHours?.length ? (
        <div className="hartuTimeSelect__empty">
        </div>
      ) : (
        <select
          ref={selectRef}
          className="hoursSelect"
        />
      )}
    </div>
  );
}
